import { ArrowLeftColor } from "@components";
import { PATH_BADGES_DETAIL, PATH_HOME } from "@configs";
import { IMemberTier } from "@interfaces";
import { selectMerchant } from "@redux";
import { RenderMeta } from "@utils";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import styled from "styled-components";

interface IProps {
    socials: JSX.Element[];
    avatar: string;
    fullName: string;
    memberTier: IMemberTier | undefined;
    isConfirm?: boolean;
}

export const ComponentBadges = (props: IProps) => {
    //page props
    const { socials } = props;
    const { t } = useTranslation();
    const merchant = useSelector(selectMerchant);
    const history = useHistory();
    const { themes } = useSelector(selectMerchant);

    return (
        <>
            <RenderMeta title={t("meta.badges_page")} />
            <StlyedBadges themeColor={themes?.themeColor!}>
                <div className="back-arrow">
                    <ArrowLeftColor
                        color={themes?.themeColor}
                        onClick={() => history.push(PATH_HOME)}
                    />
                    {/* <span>{t("page.back")}</span> */}
                </div>
                <div className="titlepage">
                    <h2>Badges</h2>
                    <p>Earn permanent badge and cement your place in the The Store society! </p>
                </div>
                <div className="layout-badges">
                    <div className="box-badges" onClick={() => history.push(PATH_BADGES_DETAIL)}>
                        <div className="img-badges">
                            <img src="../images/img-badges-list-01.png" alt="" />
                        </div>
                        <div className="text-badges">
                            <h3>Brand Ambassador</h3>
                            <p>Invite 5 friends</p>
                            <div className="process-badges">
                                <div className="text">Completed</div>
                                <div className="dots-process-badges full">
                                    <span className="done"></span>
                                    <span className="done"></span>
                                    <span className="done"></span>
                                    <span className="done"></span>
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="box-badges" onClick={() => history.push(PATH_BADGES_DETAIL)}>
                        <div className="img-badges">
                            <img src="../images/img-badges-list-02.png" alt="" />
                        </div>
                        <div className="text-badges">
                            <h3>Social star</h3>
                            <p>Participate in 5 hashtag contests</p>
                            <div className="process-badges">
                                <div className="text">Completed 2/5</div>
                                <div className="dots-process-badges">
                                    <span className="done"></span>
                                    <span className="done"></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="box-badges" onClick={() => history.push(PATH_BADGES_DETAIL)}>
                        <div className="img-badges">
                            <img src="../images/img-badges-list-03.png" alt="" />
                        </div>
                        <div className="text-badges">
                            <h3>Survey master</h3>
                            <p>Complete 5 surveys</p>
                            <div className="process-badges">
                                <div className="text">Completed 2/5</div>
                                <div className="dots-process-badges">
                                    <span className="done"></span>
                                    <span className="done"></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="box-badges" onClick={() => history.push(PATH_BADGES_DETAIL)}>
                        <div className="img-badges">
                            <img src="../images/img-badges-list-04.png" alt="" />
                        </div>
                        <div className="text-badges">
                            <h3>Master collector</h3>
                            <p>Complete 3 collection missions</p>
                            <div className="process-badges">
                                <div className="text">Completed 2/3</div>
                                <div className="dots-process-badges">
                                    <span className="done"></span>
                                    <span className="done"></span>
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="box-badges" onClick={() => history.push(PATH_BADGES_DETAIL)}>
                        <div className="img-badges">
                            <img src="../images/img-badges-list-05.png" alt="" />
                        </div>
                        <div className="text-badges">
                            <h3>Community leader</h3>
                            <p>Join 5 community events</p>
                            <div className="process-badges">
                                <div className="text">Completed 2/5</div>
                                <div className="dots-process-badges">
                                    <span className="done"></span>
                                    <span className="done"></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="box-badges" onClick={() => history.push(PATH_BADGES_DETAIL)}>
                        <div className="img-badges">
                            <img src="../images/img-badges-soon.png" alt="" />
                        </div>
                        <div className="text-badges"></div>
                    </div>
                </div>
            </StlyedBadges>
        </>
    );
};

const StlyedBadges = styled.div<{ themeColor: string }>`
    width: 100%;
    margin: 0 auto;
    height: 100vh;
    background-position: right top;
    background-repeat: no-repeat;
    background-image: url(../../images/bg-badges.png);
    position: relative;
    background-size: cover;
    .titlepage {
        text-align: center;
        margin-bottom: 16px;
        padding: 30px 16px 0;
        h2 {
            font-size: 16px;
            font-weight: 600;
            color: #000;
            margin-bottom: 5px;
        }
        p {
            font-size: 14px;
            color: #525257;
            line-height: 20px;
            max-width: 250px;
            margin: 0 auto;
        }
    }
    .layout-badges {
        position: relative;
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
        background-color: #fff;
        padding: 50px 16px;
        display: grid;
        overflow: hidden;
        grid-template-columns: 1fr 1fr;
        gap: 20px;
        .box-badges {
            position: relative;
            .img-badges {
                height: auto;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
            .text-badges {
                position: absolute;
                bottom: 50px;
                left: 16px;
                width: calc(100% - 32px);
                h3 {
                    font-size: 14px;
                    font-weight: 600;
                    color: #fff;
                }
                p {
                    font-size: 10px;
                    color: #fff;
                }
                .process-badges {
                    .text {
                        text-align: right;
                        font-size: 10px;
                        color: #fff;
                        margin-bottom: 5px;
                    }
                    .dots-process-badges {
                        display: flex;
                        gap: 4px;
                        span {
                            width: 100%;
                            height: 3px;
                            border-radius: 20px;
                            background-color: #d1cbc9;
                        }
                        .done {
                            background-color: #000;
                        }
                    }
                    .dots-process-badges.full {
                        span {
                            background-color: #f44237 !important;
                        }
                    }
                }
            }
        }
    }
    .back-arrow {
        position: absolute;
        left: 10px;
        top: 15px;
        display: flex;
        align-items: center;
        z-index: 1;
        span {
            margin-left: 10px;
            color: ${(p) => p.themeColor};
        }
    }
    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px;
        .title-group {
            text-align: center;
        }
        h4 {
            flex: 1;
            display: flex;
            justify-content: center;
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 25px;
            color: #000000;
        }
    }
`;
const StyledUsedBtn = styled.button<{ themeColor: string }>`
    padding: 3px 12px;
    color: ${(p) => p.theme.colors.card};
    background: ${(p) => p.themeColor};
    border: 0.5px solid ${(p) => p.themeColor};
    border-radius: 40px;
    cursor: pointer;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    height: 48px;
    width: 100%;
    &:active {
        opacity: 0.8;
    }
`;
